import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

interface STOProps {
  isselected?: boolean;
  disabled?:  boolean;
}
  
export const StyledTotemOption = styled.button<STOProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  border: ${({ isselected }) =>
    isselected ? "0.25rem" : "0.125rem"} solid ${Colors.primary[100]};
  border-radius: 1rem;

  height: 200px;
  width: 200px;
  padding: 0.5rem; /* opcional */

  background-color: ${({ disabled }) =>
    disabled ? Colors.commons.grayFading : Colors.commons.white};

  opacity: ${({ disabled }) =>
    disabled ? "50%" : "100%"};

  color: ${Colors.primary[100]};
  font-size: 1.25rem;

  font-weight: ${({ isselected }) =>
    isselected ? "bold" : "normal"};

    line-height: 1rem;
`;
  